import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { BarChart2 } from 'lucide-react'

export default function TeamAnalyticsPlaceholder() {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <header className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <BarChart2 className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Team analytics</h1>
            <p className="text-muted-foreground">Advanced charts from the Next.js dashboard are pending migration.</p>
          </div>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>Insights coming soon</CardTitle>
            <CardDescription>
              Bring over the KPI cards and chart components (`TeamHealthScoreChart`, `TeamHealthVisualization`, etc.) to finish this page.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">
              In the meantime use the main team dashboard to review feedback stats.
            </p>
            <Button asChild>
              <Link to="/dashboard/team">Back to team overview</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
